import { ObjectMode } from '@databases/types';
import { Database, DatabaseFieldType } from '@databases/types/database';
import { createField, getNewDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

export const getDatabaseWithSelfReferenceEntryLinkField =
  (): Database<ObjectMode.EXISTING> => {
    const baseDatabase = getNewDatabase();

    const baseEntryLinkField = createField(DatabaseFieldType.ENTRY_LINK);
    const fields = [
      {
        ...createField(DatabaseFieldType.TEXT),
        name: `Text Field`,
      },
      {
        ...baseEntryLinkField,
        name: `Entry Link Field`,
        settings: {
          ...baseEntryLinkField.settings,
          contentId: databasesToContentId['databaseWithSelfReferenceEntryLinkField'],
        },
      },
    ];

    return {
      ...baseDatabase,
      fields: fields.map((field) => field.id),
      fieldsById: Object.fromEntries(fields.map((field) => [field.id, field])),
      contentId: databasesToContentId['databaseWithSelfReferenceEntryLinkField'],
      meta: {
        ...baseDatabase.meta,
        isLocked: false,
      },
      space: { key: 'TEST', name: 'Test', id: 1234 },
      operations: {
        delete: false,
        updateEntries: true,
        updateMetadata: true,
      },
    } as Database<ObjectMode.EXISTING>;
  };
